/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React from "react";

import { Stack, StackItem, Text } from "@fluentui/react";

import { SidePanel } from "Components/SidePanel/SidePanel";

import { IDistributionListsJoinRequestFormProps } from "./DistributionListsJoinRequestFormProps";
import {
  dlFormJoinRequestLabelStyles,
  dlStackItemStyles,
} from "./DistributionListsJoinRequestFormProps.styles";

const DistributionListsJoinRequestForm: React.FunctionComponent<
  IDistributionListsJoinRequestFormProps
> = (props) => {
  const { isOpen, error, disableActions, dlJoinRequest, onSave, onDismiss, onCancel } = props;
  return (
    <SidePanel
      isOpen={isOpen}
      title="DL Join Request"
      disableActions={disableActions}
      error={error}
      onSave={onSave}
      onDismiss={onDismiss}
      onCancel={onCancel}
      saveButtonLabel={"Approve"}
      cancelButtonLabel={"Decline"}
    >
      <Stack styles={dlStackItemStyles} tokens={{ childrenGap: "1rem" }}>
        <StackItem>
          <Text styles={dlFormJoinRequestLabelStyles}>DL Name:</Text>
        </StackItem>
        <StackItem>{dlJoinRequest?.distributionListName}</StackItem>
      </Stack>
      <Stack styles={dlStackItemStyles} tokens={{ childrenGap: "1rem" }}>
        <StackItem>
          <Text styles={dlFormJoinRequestLabelStyles}>DL Technology Category:</Text>
        </StackItem>
        <StackItem>{dlJoinRequest?.distributionListTechCategory}</StackItem>
      </Stack>
      <Stack styles={dlStackItemStyles} tokens={{ childrenGap: "1rem" }}>
        <StackItem>
          <Text styles={dlFormJoinRequestLabelStyles}>Reason to join:</Text>
        </StackItem>
        <StackItem>{dlJoinRequest?.justificationToJoin}</StackItem>
      </Stack>
      <Stack styles={dlStackItemStyles} tokens={{ childrenGap: "1rem" }}>
        <StackItem>
          <Text styles={dlFormJoinRequestLabelStyles}>Name:</Text>
        </StackItem>
        <StackItem>
          {dlJoinRequest?.firstName} {dlJoinRequest?.lastName}
        </StackItem>
      </Stack>
      <Stack styles={dlStackItemStyles} tokens={{ childrenGap: "1rem" }}>
        <StackItem>
          <Text styles={dlFormJoinRequestLabelStyles}>Email:</Text>
        </StackItem>
        <StackItem>{dlJoinRequest?.emailAddress}</StackItem>
      </Stack>
      <Stack styles={dlStackItemStyles} tokens={{ childrenGap: "1rem" }}>
        <StackItem>
          <Text styles={dlFormJoinRequestLabelStyles}>Technology Areas:</Text>
        </StackItem>
        <StackItem>{dlJoinRequest?.technologyAreas}</StackItem>
      </Stack>
    </SidePanel>
  );
};

export default DistributionListsJoinRequestForm;
